import React from 'react';
import { useState } from 'react';
import { FieldError } from 'react-hook-form';
import useTranslation from '../../../Hooks/useTranslation';
import { useValidation } from '../../Utils/Validation';
import AsyncSelect from '../Select/AsyncSelect';
import { SelectValue } from '../Select/Select';
import Text from '../Text/Text';
// @ts-ignore
import styles from './DynamicSelect.module.scss';

interface DynamicSelectProps<T> {
	onChange?: (value: SelectValue) => void;
	value?: SelectValue;
	error?: FieldError;
	searchItems: (searchInput: string) => Promise<SelectValue[]>;
	ItemTemplate?: (item: T) => React.ReactElement;
	placeholder?: string;
	portal?: boolean;
	showErrorMessage?: boolean;
}

const DynamicSelect = <T,>(
	props: DynamicSelectProps<T>,
): React.ReactElement => {
	const {
		onChange,
		value,
		error,
		searchItems,
		ItemTemplate,
		placeholder,
		portal,
		showErrorMessage = true,
	} = props;
	const { t } = useTranslation();
	const { fillErrorMessage } = useValidation();
	const [searchTimeout, setSearchTimeout] = useState<number | undefined>(
		undefined,
	);

	const loadOptions = (
		inputValue: string,
		callback: (options: SelectValue[]) => void,
	) => {
		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}

		// @ts-ignore
		const wCall = async () => {
			const options = await searchItems(inputValue);
			callback(options);
		};

		setSearchTimeout(
			setTimeout(() => {
				wCall();
			}, 500),
		);
	};

	return (
		<div style={{ flex: 1 }}>
			<AsyncSelect
				value={value}
				onSearch={loadOptions}
				onChange={newValue => {
					if (newValue) {
						onChange?.(newValue);
					}
				}}
				placeholder={
					(value && value.label) || t(placeholder) || t('base.shared.pick')
				}
				noOptionsMessage={t('base.startTyping')}
				error={error}
				ItemTemplate={ItemTemplate}
				portal={portal}
			/>
			{showErrorMessage && error && (
				<div className={styles.errorMessage}>
					<Text tx={fillErrorMessage(error)} inline={true} />
				</div>
			)}
		</div>
	);
};

export default DynamicSelect;
